// extracted by mini-css-extract-plugin
module.exports = {"videos":"video_list_videos__3u9ea"};